{
  "$id": "module://plan-management",
  "$schema": "wealthlane://schemas/domain",
  "title": "Plan Management",
  "description": "Plan Management field catalog — maps to PlanService DTO",
  "type": "object",
  "properties": {
    "name": {
      "type": "string",
      "title": "Plan Name",
      "widget": "text",
      "noBlank": true,
      "noDoubleSpace": true,
      "maxLength": 100
    },
    "uniquePlanNo": {
      "type": "string",
      "title": "Plan Number",
      "widget": "label",
      "displayFormat": "badge",
      "badgeVariant": "primary"
    },
    "planTypeCategoryIds": {
      "type": "array",
      "title": "Award Type",
      "widget": "select"
    },
    "boardApprovalDate": {
      "type": "string",
      "title": "Board Approval Date",
      "widget": "date",
      "format": "date"
    },
    "shareHolderApprovalDate": {
      "type": "string",
      "title": "Shareholder Approval Date",
      "widget": "date",
      "format": "date"
    },
    "planEffectiveDate": {
      "type": "string",
      "title": "Plan Effective Date",
      "widget": "date",
      "format": "date"
    },
    "poolId": {
      "$ref": "module://share-pool#/$defs/poolId"
    },
    "planTerm": {
      "type": "number",
      "title": "Plan Term",
      "widget": "number",
      "minimum": 1,
      "inputPrecision": 0,
      "endAddon": "YEAR"
    },
    "evergreenPlan": {
      "type": "string",
      "title": "Evergreen Plan",
      "widget": "select",
      "default": "No",
      "options": [
        { "label": "Yes", "value": "Yes" },
        { "label": "No", "value": "No" }
      ]
    },
    "evergreenCriteria": {
      "type": "string",
      "title": "Evergreen Criteria",
      "widget": "text",
      "maxLength": 500
    },
    "dividendEligibility": {
      "type": "string",
      "title": "Dividend Eligibility",
      "widget": "select",
      "default": "No",
      "options": [
        { "label": "Yes", "value": "Yes" },
        { "label": "No", "value": "No" }
      ]
    },
    "planExpiryDate": {
      "type": "string",
      "title": "Plan Expiry Date",
      "widget": "date",
      "format": "date"
    },
    "description": {
      "type": "string",
      "title": "Description",
      "widget": "textarea",
      "maxLength": 1000,
      "adapterProps": { "rows": 4 }
    },
    "allowEditPlanRelatedDocuments": {
      "type": "boolean",
      "title": "Allow Edit on Plan Related Documents",
      "widget": "checkbox"
    },
    "planDocumentInput": {
      "type": "file",
      "title": "Upload Plan Documents",
      "accept": ".pdf,.jpg,.jpeg,.png,.docx,.doc",
      "maxSize": 10485760,
      "fileUpload": {
        "multiple": true,
        "maxFiles": 10,
        "existingId": "#/properties/planDocumentExistingIds",
        "existingName": "#/properties/planDocumentExistingNames",
        "removedIds": "#/properties/planDocumentRemovedIds",
        "submit": {
          "selection": "all",
          "arrayKey": "planDocument",
          "deleteIdsKey": "planDocumentDetails"
        }
      }
    },
    "planDocumentExistingIds": {
      "type": "array",
      "items": { "type": "string" },
      "title": "Existing Plan Document IDs",
      "widget": "hidden",
      "default": []
    },
    "planDocumentExistingNames": {
      "type": "array",
      "items": { "type": "string" },
      "title": "Existing Plan Document Names",
      "widget": "hidden",
      "default": []
    },
    "planDocumentRemovedIds": {
      "type": "array",
      "items": { "type": "string" },
      "title": "Removed Plan Document IDs",
      "widget": "hidden",
      "default": []
    },
    "optionExpirationDate": {
      "type": "number",
      "title": "Option Expiration Term",
      "widget": "number",
      "minimum": 1,
      "inputPrecision": 0,
      "endAddon": "YEAR"
    },
    "terminationRules": {
      "type": "array",
      "title": "Termination Rules",
      "widget": "hidden",
      "default": []
    },
    "terminationRuleSetId": {
      "type": "string",
      "title": "Termination Rule Set ID",
      "widget": "hidden"
    },
    "planTypeCategory": {
      "type": "array",
      "title": "Plan Type Category Labels",
      "widget": "hidden",
      "default": []
    },
    "OPEN_TERMINATION_RULES_MODAL": {
      "type": "action-button",
      "label": "Add Termination Rules",
      "icon": "add_circle_outline",
      "variant": "primary-outline"
    },
    "OPEN_GRANT_AGREEMENT_MODAL": {
      "type": "action-button",
      "label": "Add Grant Agreement",
      "icon": "add_circle_outline",
      "variant": "primary-outline"
    },
    "OPEN_GRANT_NOTICE_MODAL": {
      "type": "action-button",
      "label": "Add Grant Notice",
      "icon": "add_circle_outline",
      "variant": "primary-outline"
    },
    "OPEN_TERMS_CONDITIONS_DOC_MODAL": {
      "type": "action-button",
      "label": "Add Terms and Conditions Document",
      "icon": "add_circle_outline",
      "variant": "primary-outline"
    },
    "OPEN_TERMS_CONDITIONS_TEXT_MODAL": {
      "type": "action-button",
      "label": "Add Terms and Conditions Text",
      "icon": "add_circle_outline",
      "variant": "primary-outline"
    },
    "grantAgreementDocs": {
      "type": "array",
      "title": "",
      "widget": "document-list",
      "default": []
    },
    "grantNoticeDocs": {
      "type": "array",
      "title": "",
      "widget": "document-list",
      "default": []
    },
    "termsConditionDocDocs": {
      "type": "array",
      "title": "",
      "widget": "document-list",
      "default": []
    },
    "termsConditionTextDocs": {
      "type": "array",
      "title": "",
      "widget": "document-list",
      "default": []
    }
  }
}
